// extracted by mini-css-extract-plugin
module.exports = {"fill":"Avatar_fill__7S0A3"};